<template>
    <div v-if="componentLoader" class="position-relative h-100">
        <app-overlay-loader/>
    </div>
    <div v-else>
        <app-overlay-loader v-if="preloader"/>
        <form class="mb-0" v-else ref="form" data-url="admin/auth/users/change-settings"
              :class="{'loading-opacity': preloader}">
            <div class="form-group">
                <div class="row">
                    <div class="col-lg-3 col-xl-3 d-flex align-items-center">
                        <label for="user_first_name" class="text-left d-block mb-lg-2 mb-xl-0">
                            {{ $t('first_name') }}
                        </label>
                    </div>
                    <div class="col-lg-8 col-xl-8">
                        <app-input id="user_first_name"
                                   type="text"
                                   :placeholder="$t('type_first_name')"
                                   v-model="inputs.first_name"
                                   :read-only="userRole.id == inputs.id ? false : true"
                                   :required="true"/>
                                   <!-- v-model="user.loggedInUser.first_name" -->
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-lg-3 col-xl-3 d-flex align-items-center">
                        <label for="user_last_name" class="text-left d-block mb-lg-2 mb-xl-0">
                            {{ $t('last_name') }}
                        </label>
                    </div>
                    <div class="col-lg-8 col-xl-8">
                        <app-input id="user_last_name"
                                   type="text"
                                   :placeholder="$t('type_last_name')"
                                   v-model="inputs.last_name"
                                   :read-only="userRole.id == inputs.id ? false : true"
                                   :required="true"/>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-lg-3 col-xl-3 d-flex align-items-center">
                        <label for="user_email" class="text-left d-block mb-lg-2 mb-xl-0">
                            {{ $t('email') }}
                        </label>
                    </div>
                    <div class="col-lg-8 col-xl-8">
                        <app-input id="user_email"
                        :read-only="userRole.id == inputs.id ? false : true"
                        type="email" :placeholder="$t('type_your_email')" v-model="inputs.email"/>
                    </div>
                </div>
            </div>
            <!-- <div class="form-group">
                <div class="row">
                    <div class="col-lg-3 col-xl-3 d-flex align-items-center">
                        <label class="text-left d-block mb-lg-2 mb-xl-0">{{ $t('gender') }}</label>
                    </div>
                    <div class="col-lg-8 col-xl-8">
                        <app-input type="radio"
                                   :list="genderList"
                                   v-model="user.loggedInUser.gender"/>
                    </div>
                </div>
            </div> -->
            <div class="form-group">
                <div class="row">
                    <div class="col-lg-3 col-xl-3 d-flex align-items-center">
                        <label for="user_contact" class="text-left d-block mb-lg-2 mb-xl-0">
                            {{ $t('contact_number') }}
                        </label>
                    </div>
                    <div class="col-lg-8 col-xl-8">
                        <app-input id="user_contact"
                                   type="tel-input"
                                   v-model="inputs.phone"
                                   :placeholder="$t('type_contact_number')"/>
                    </div>
                </div>
            </div>
      <div class="form-group">
                <div class="row">
                    <div class="col-lg-3 col-xl-3 d-flex align-items-center">
                        <label for="user_address" class="text-left d-block mb-lg-2 mb-xl-0">
                            {{ $t('address') }}
                        </label>
                    </div>
                    <div class="col-lg-8 col-xl-8">
                        <app-input id="user_address"
                                   type="textarea"
                                   v-model="inputs.address"
                                   :read-only="userRole.id == inputs.id ? false : true"
                                   :placeholder="$t('type_address')"/>
                    </div>
                </div>
            </div>
           <div class="form-group">
                <div class="row">
                    <div class="col-lg-3 col-xl-3 d-flex align-items-center">
                        <label for="user_date_of_birth" class="text-left d-block mb-lg-2 mb-xl-0">
                            {{ $t('date_of_birth') }}
                        </label>
                    </div>
                    <div class="col-lg-8 col-xl-8">
                        <app-input id="user_date_of_birth"
                                   type="date"
                                   v-model="inputs.date_of_birth"/>
                    </div>
                </div>
            </div>
          <div class="form-group" v-if="isCompanyAdmin">
            <div class="row">
              <div class="col-lg-3 col-xl-3 d-flex align-items-center">
                <label for="update_info" class="text-left d-block mb-lg-2 mb-xl-0">
                  {{ $t('Update Info') }}
                </label>
              </div>
              <div class="col-lg-8 col-xl-8">
                <app-input id="user_date_of_birth"
                           type="select"
                           :list="list"
                           v-model="inputs.update_info"/>
              </div>
            </div>
          </div>

            <div class="form-group mb-0 mt-5" v-if="userRole.id == inputs.id">
                <div class="row">
                    <div class="col-12 action-buttons">
                        <button type="button" class="btn btn-primary mr-2" @click.prevent="openModal">
                            {{ $t('save') }}
                        </button>
                    </div>
                </div>
            </div>
        </form>
           <app-modal v-if="setModal"
                           modal-id="alert-modal"
                           modal-alignment="center"
                           modal-size="md"
                           @close-modal="closeModal">
                    <div class="modal-body d-flex flex-column justify-content-center modal-alert">
                        <div class="text-center">
                            <app-icon class="text-warning" :name="'alert-triangle'"/>
                        </div>
                        <h5 class="text-center font-weight-bold mt-4">{{ $t('alert')+'!' }}</h5>
                        <p class="text-center mb-4 font-size-90">{{ $t('Please enter password for verfication') }}</p>
                         <app-input type="password" v-model="inputs.password" placeholder="Enter Password"/>
                         <small v-html="message" class="text-danger ml-2"></small>

                        <div class="text-center mt-3">
                            <a href="#" class="btn btn-warning" @click="submit">
                                {{ $t('continue') }}
                            </a>
                        </div>
                    </div>
                </app-modal>
    </div>
</template>

<script>
    import GlobalHelperMixin from "../../../Mixins/global/GlobalHelperMixin";
    import {FormMixin} from "../../../../core/mixins/form/FormMixin";
    import {UserMixin} from "./Mixins/UserMixin";
    import * as actions from "../../../Config/ApiUrl";
    import AppLibrary from "../../../Helpers/AppLibrary";

    export default {
        name: "PersonalInformation",
        extends: AppLibrary,
        mixins: [FormMixin, UserMixin, GlobalHelperMixin],
        data() {
            return {
                // inputType: this.$attrs['props'].type,
                preloader: false,
              isCompanyAdmin: this.$store.state.user.loggedInUser.is_company_admin === 1,
              genderList: [
                {
                  id: 'male',
                  value: 'Male'
                },
                {
                  id: 'female',
                  value: 'Female'
                }
              ],
              list: [
                {
                  id: 1,
                  value: 'Yes'
                },
                {
                  id: 0,
                  value: 'No'
                },
              ],
                setModal:false,
                // inputs: this.$store.state.user.loggedInUser,
                inputs: this.$attrs['props'].userData,
                message: '',
                info: {},

            }
        },
        computed: {
            userRole() {
            return this.$store.state.user.loggedInUser;
            },
        },
        methods: {
            beforeSubmit() {
                this.scrollToTop(true);
                this.preloader = true;
            },
            openModal() {
                this.setModal = true
            },
            submit() {
                    if (this.inputs.password == null) {
                        this.message = 'Password Field Is Required';
                    }
                    else {
                        let submitData = this.user.loggedInUser;
                        if (submitData.date_of_birth) submitData.date_of_birth = this.getDateFormatForBackend(submitData.date_of_birth);
                        else submitData.date_of_birth = null;

                            this.info = {
                             'first_name': this.inputs.first_name,
                              'last_name': this.inputs.last_name,
                              'email': this.inputs.email,
                              'phone': this.inputs.phone,
                              'password': this.inputs.password,
                              'address': this.inputs.address,
                              'update_info': this.inputs.update_info,
                        };
                        this.save(this.info);
                    }
            },
            closeModal(){
              this.setModal = false;
            },
            afterFinalResponse() {
                this.preloader = false;
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                this.setModal = false;
                window.location = actions.MY_PROFILE;
            },
            afterError(res) {
                this.$toastr.e(res.data.error);
            },
        }
    }
</script>
